// Property data with translation keys
export const PROPERTIES_DATA = [
  {
    id: 1,
    nameKey: 'properties.property1Name',
    locationKey: 'properties.property1Location',
    descKey: 'properties.property1Desc',
    area: 'Žnjan',
    pricePerNight: '€250',
    priceNumber: 250,
    beds: 4,
    baths: 3,
    guests: 8,
    image: 'https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=800&q=80',
    badge: 'popular',
    badgeColor: 'bg-primary text-black',
    features: ['pool', 'parking', 'wifi', 'aircon'],
  },
  {
    id: 2,
    nameKey: 'properties.property2Name',
    locationKey: 'properties.property2Location',
    descKey: 'properties.property2Desc',
    area: 'Stari Grad',
    pricePerNight: '€120',
    priceNumber: 120,
    beds: 2,
    baths: 1,
    guests: 4,
    image: 'https://images.unsplash.com/photo-1493809842364-78817add7ffb?w=800&q=80',
    badge: 'center',
    badgeColor: 'bg-white text-black',
    features: ['wifi', 'aircon', 'kitchen', 'washer'],
  },
  {
    id: 3,
    nameKey: 'properties.property3Name',
    locationKey: 'properties.property3Location',
    descKey: 'properties.property3Desc',
    area: 'Bačvice',
    pricePerNight: '€180',
    priceNumber: 180,
    beds: 3,
    baths: 2,
    guests: 6,
    image: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=800&q=80',
    badge: 'seaView',
    badgeColor: 'bg-primary text-black',
    features: ['seaView', 'terrace', 'wifi', 'aircon'],
  },
  {
    id: 4,
    nameKey: 'properties.property4Name',
    locationKey: 'properties.property4Location',
    descKey: 'properties.property4Desc',
    area: 'Meje',
    pricePerNight: '€85',
    priceNumber: 85,
    beds: 1,
    baths: 1,
    guests: 2,
    image: 'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=800&q=80',
    badge: 'new',
    badgeColor: 'bg-white text-black',
    features: ['wifi', 'aircon', 'kitchen', 'parking'],
  },
  {
    id: 5,
    nameKey: 'properties.property5Name',
    locationKey: 'properties.property5Location',
    descKey: 'properties.property5Desc',
    area: 'Firule',
    pricePerNight: '€320',
    priceNumber: 320,
    beds: 5,
    baths: 4,
    guests: 10,
    image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&q=80',
    badge: 'luxury',
    badgeColor: 'bg-primary text-black',
    features: ['pool', 'garden', 'parking', 'bbq'],
  },
  {
    id: 6,
    nameKey: 'properties.property6Name',
    locationKey: 'properties.property6Location',
    descKey: 'properties.property6Desc',
    area: 'Marjan',
    pricePerNight: '€140',
    priceNumber: 140,
    beds: 2,
    baths: 2,
    guests: 4,
    image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&q=80',
    badge: 'beachfront',
    badgeColor: 'bg-white text-black',
    features: ['seaView', 'terrace', 'wifi', 'parking'],
  },
];

export const getPropertyById = (id) => PROPERTIES_DATA.find(p => p.id === parseInt(id));
export const getRelatedProperties = (id, limit) => PROPERTIES_DATA.filter(p => p.id !== parseInt(id)).slice(0, limit);
